import React from "react";
import "../styles/pages.css";

function CouponBook() {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h2 className="hero-title">COUPONBOOK</h2>
        <p className="hero-subtitle">Smart Coupon Management Solution</p>
      </div>
      <div className="coming-soon">
        <h2>Coming Soon</h2>
        <p>We're preparing a new coupon management system</p>
      </div>
    </div>
  );
}

export default CouponBook;
